const initialState = {
  data: null,
};

const mailRedirectData = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_MAIL_DATA':
      return {
        ...state,
        mailData: action.payload?.data,
      };
    default:
      return state;
  }
};

export default mailRedirectData;
